import { useParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { routes } from '~constants/routes';
import { NsfwReason } from '~features/annals';
import { useCurrentBot } from '~hooks/useCurrentBot';
import { useSession } from '~hooks/useSession';
import { useRouter } from '~i18n/navigation';

import { useSwitchSafeModeWithAgeValidation } from './useSwitchSafeMode';

export const useChatAutoModeSwitch = () => {
	const router = useRouter();
	const { recipientId = '' } = useParams<{ recipientId?: string }>();
	const { isSafeMode } = useSession();

	const { isSafeBot, bot } = useCurrentBot({
		recipientId,
	});
	const switchSafeMode = useSwitchSafeModeWithAgeValidation();

	const processing = useRef(false);

	useEffect(() => {
		if (!bot.uid || isSafeBot) return;

		if (isSafeMode) {
			if (!processing.current) {
				switchSafeMode(false, {
					nsfwReason: NsfwReason.NavigationLink,
					force: true,
				})
					.catch(() => {
						router.replace(routes.explore.home);
					})
					.finally(() => {
						processing.current = true;
					});
			} else {
				router.replace(routes.chats.home);
			}
		} else {
			processing.current = true;
		}
	}, [switchSafeMode, isSafeMode, bot, isSafeBot, router]);
};
